import React, { useEffect, useState } from "react";
import "antd/dist/antd.css";
import "../../css/profile.css";
import HeaderText from "../../components/HeaderText";
import SubHeaderText from "../../components/SubText";
import CardTiles from "../../components/CardTiles";
import GenericButton from "../../components/GenericButton";
import CompleteProfileInfoArea from "../../components/CompleteProfileInfoArea";
import Navbar from "../../components/Navbar";
import _, { includes, isEmpty } from "lodash";
import {
  useGetDataFromDBMutation,
  useGetIndustriesMutation,
  useGetProfessionsMutation,
  useGetSkillsMutation,
  useUpdateProfileMutation,
} from "../../store/appSlice";
import { useNavigate } from "react-router-dom";
import {
  DataType,
  JobCategoryType,
  ProfessionType,
  SkillsType,
} from "../../interfaces/user";
import { useAppSelector } from "../../store/store";
import { PROFILE_COMPLETION_FOCUS_TABS } from "../../constants/stringConstants";
import JobRelatedInfoMap from "./JobRelatedInfoMap";
import { HandleNotification } from "../../components/ToastAlert";
import { useDispatch } from "react-redux";
import { setProfileComplete } from "../../reducers/userReducer";

const listData = [
  { id: 0, text: "Full time" },
  { id: 1, text: "Part time" },
  { id: 2, text: "Short-term" },
  { id: 3, text: "Project/Freelance" },
];

function JobRelatedInfo() {
  const { user } = useAppSelector((state) => state["user"]);

  const [jobCategory, setJobCategory] = useState<JobCategoryType[] | undefined>(
    []
  );
  const [selectedJobCategoryID, setSelectedJobCategoryID] = useState<
    Number | string
  >();

  const [selectedJobCategoryText, setSelectedJobCategoryText] =
    useState<Array<string>>();

  const [jobProfession, setJobProfession] = useState<
    ProfessionType[] | undefined
  >([]);

  const [selectedJobProfessionIDs, setSelectedJobProfessionIDs] = useState<
    Array<string | Number>
  >([]);

  const [selectedJobProfessionTexts, setSelectedJobProfessionTexts] = useState<
    Array<string>
  >([]);

  const [jobSkills, setJobSkills] = useState<SkillsType[] | undefined>([]);

  const [selectedJobSkillIDs, setSelectedJobSkillIDs] = useState<
    Array<string | Number>
  >([]);

  const [selectedJobSkillTexts, setSelectedJobSkillTexts] = useState<
    Array<string>
  >([]);


  const [jobCategoryError,setJobCategoryError]=useState('')
  const [professionsError,setProfessionError]=useState('')
  const [skillsError,setSkillsError]=useState('')

  const [getIndustries] = useGetIndustriesMutation();
  const [getSkills] = useGetSkillsMutation();

  const [getDataFromDB] = useGetDataFromDBMutation();
  const [getProfessions] = useGetProfessionsMutation();
  const [updateProfile] = useUpdateProfileMutation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getAllIndustriesIds();
  }, []);

  const onJobCategorySelect = (
    selected: Number | string,
    item: JobCategoryType
  ) => {
    let categories = [];
    categories.push(item.industryName);
    setSelectedJobCategoryText(categories);
    setSelectedJobCategoryID(selected);
    let industryIds = [];
    industryIds.push(selected);

    const payload = {
      industryIds,
      param: user?.id,
    };

    setSelectedJobProfessionIDs([])
    setSelectedJobSkillIDs([]);
    setJobProfession([])
    setJobSkills([])
    setSelectedJobProfessionTexts([])
    setSelectedJobSkillTexts([])

    updateProfile(payload)
      .unwrap()
      .then((incomingData) => {
        getIndustryIdsFromDb();
      })
      .catch((err) => {});
  };

  const onJobProfessionSelect = (
    selected: Number | string,
    item: ProfessionType
  ) => {
    setJobSkills([])
    setSelectedJobSkillTexts([])

    let professionTexts: Array<string> = [...selectedJobProfessionTexts];
    let professionIds: Array<string | Number> = [...selectedJobProfessionIDs];
    if (includes(professionTexts, item.professionName)) {
      let filteredArrayProfessionsText = professionTexts.filter(function (e) {
        return e !== item.professionName;
      });
      setSelectedJobProfessionTexts(filteredArrayProfessionsText);
    } else {
      if (professionIds.length < 3) {
        professionTexts.push(item.professionName);
        setSelectedJobProfessionTexts(professionTexts);
      } else {
      }
    }

    if (includes(professionIds, selected)) {
      let filteredArrayProfessionIds = professionIds.filter(function (e) {
        return e !== selected;
      });

      setSelectedJobProfessionIDs(filteredArrayProfessionIds);
    } else {
      if (professionIds.length < 3) {
        professionIds.push(selected);
        setSelectedJobProfessionIDs(professionIds);
      } else {
        HandleNotification("Cannot add more than 3 professions");
      }
    }
    const payload = {
      professionIds,
      param: user?.id,
    };

    updateProfile(payload)
      .unwrap()
      .then((payload) => {
        getProfessionsIdsFromDb();
      })
      .catch((err) => {});
  };

  const onJobSkillsSelect = (selected: Number | string, item: SkillsType) => {
    let skillsName: Array<string> = [...selectedJobSkillTexts];
    let skillsIDs: Array<string | Number> = [...selectedJobSkillIDs];
    if (includes(skillsName, item.skillName)) {
      let filteredArraySkillsName = skillsName.filter(function (e) {
        return e !== item.skillName;
      });
      setSelectedJobSkillTexts(filteredArraySkillsName);
    } else {
      if (skillsIDs.length < 15) {
        skillsName.push(item.skillName);
        setSelectedJobSkillTexts(skillsName);
      } else {
      }
    }

    if (includes(skillsIDs, selected)) {
      let filteredArraySkillIds = skillsIDs.filter(function (e) {
        return e !== selected;
      });
      setSelectedJobSkillIDs(filteredArraySkillIds);
    } else {
      if (skillsIDs.length < 15) {
        skillsIDs.push(selected);
        setSelectedJobSkillIDs(skillsIDs);
      } else {
        HandleNotification("Cannot add more than 15 skills");
      }
    }

  };

  const getAllIndustriesIds = async () => {
    const filterDetails = encodeURIComponent(`
  {
    "where" : { 
      "isActive": true
    }
  }
      `);

    let data = {
      filterDetails,
    };

    getIndustries(data)
      .unwrap()
      .then((payload) => {
        setJobCategory(payload);
      })
      .catch((err) => {});
  };

  // Get Skills if saved to db
  const getIndustryIdsFromDb = async () => {
    const filterDetails = encodeURIComponent(`
{
    "fields": {
        "industryIds": true,
        "professionIds": true
    }
}
    `);

    let data = {
      filterDetails,
      param: user?.id ?? "",
    };

    getDataFromDB(data)
      .unwrap()
      .then((payload) => {
        getAllProfessionsIds(payload?.candidate?.industryIds);
      })
      .catch((err) => {});
  };

  const getAllProfessionsIds = async (id: Array<string> | undefined) => {
    if (!_.isNil(id)) {
      getProfessions(id[0])
        .unwrap()
        .then((payload) => {
          setJobProfession(payload);
        })
        .catch((err) => {});
    }
  };

  // Get Skills if saved to db
  const getProfessionsIdsFromDb = async () => {
    const filterDetails = encodeURIComponent(`
  {
      "fields": {
          "professionIds": true,
          "skillIds": true
      }
  }
      `);

    let data = {
      filterDetails,
      param: user?.id ?? "",
    };
    setSelectedJobSkillIDs([]);

    getDataFromDB(data)
      .unwrap()
      .then((payload) => {
        getAllSkillsIds(payload?.candidate?.professionIds);
      });
  };

  const getAllSkillsIds = async (professionIds: Array<string> | undefined) => {
    const reqPayload = {
      professionIds,
    };
    if (!_.isNil(professionIds)) {
      getSkills(reqPayload)
        .unwrap()
        .then((payload) => {
          setJobSkills(payload);
        })
        .catch((err) => {});
    }
  };

  const validation=()=>{
    setJobCategoryError('')
    setProfessionError('')
    setSkillsError('')
    let isValid=true
    if(isEmpty(selectedJobCategoryID)){
      isValid=false
     setJobCategoryError('You need to select a job category')
    }
    if(isEmpty(selectedJobProfessionIDs) && !isEmpty(jobProfession) ){

      isValid=false
      setProfessionError('You need to select atleast 1 profession')
     }
     if(isEmpty(selectedJobSkillIDs) && !isEmpty(jobSkills)){

      isValid=false
      setSkillsError('You need to select atleast 1 skill')
     }
     return isValid
  }

  const onContinue = () => {


    if(validation()){

    const payload = {
      skillIds: selectedJobSkillIDs,
      isSignUpProcessCompleted: true,
      param: user?.id,
    };
    updateProfile(payload)
      .unwrap()
      .then((payload) => {
        dispatch(setProfileComplete(true));
        navigate("/", { replace: true,state: {
     fromSignupCompletion:true
        }, });

    
      })
      .catch((err) => {});
    }
  };

const errorSec=(err:string)=>(
  <div style={{marginLeft:25}}><h4 style={{color:'red',fontWeight:'700'}}>{err}</h4></div>
)

  
  return (
    <div className="profile__container">
      <Navbar />
      <div style={{ marginTop: 70 }} />
      <CompleteProfileInfoArea
        focusTab={PROFILE_COMPLETION_FOCUS_TABS.JOB_RELATED_INFO}
      />

      {/* 1st screen */}
      <div style={{ flexDirection: "row", display: "flex", width: "100%" }}>
        <div className="profile_sec_container">
          <div className="job_type_container">
            <div className="header_text_screen2">
              <HeaderText text={"Select your job category"} />
              <SubHeaderText text={"You can only select only 1 option"} />
            </div>
            <div className="card_tiles_sec">
              {jobCategory &&
                jobCategory.map((item) => {
                  return (
                    <CardTiles
                      key={item.id}
                      id={item.id}
                      text={item.industryName}
                      isActive={selectedJobCategoryID === item.id}
                      setIsActive={(selected: Number | string) =>{
                        onJobCategorySelect(selected, item)
                      }}
                      getIdData={true}
                    />
                  );
                })}
            </div>
          </div>
          {!isEmpty(jobCategoryError) && errorSec(jobCategoryError)}

          {/* 2nd screen */}
          <div className="border_bottom_signup_process_heading"></div>

          <div className="job_type_container">
            <div className="header_text_screen2">
              <HeaderText text={"Add Professions"} />
              <SubHeaderText text={"You can add upto 3 options"} />
            </div>
            <div className="card_tiles_sec">
              {jobProfession &&
                jobProfession.map((item, index) => {
                  return (
                    <CardTiles
                      key={item.id}
                      id={item.id}
                      text={item.professionName}
                      isActive={includes(selectedJobProfessionIDs, item.id)}
                      setIsActive={(selected: Number) => {
                        // if (selectedJobProfessionIDs.length < 3) {

                        onJobProfessionSelect(selected, item);
                        // }
                      }}
                      getIdData={true}
                    />
                  );
                })}
            </div>
          </div>
          {!isEmpty(professionsError) && errorSec(professionsError)}

          {/* 3rd screen */}
          <div className="border_bottom_signup_process_heading"></div>

          <div className="job_type_container">
            <div className="header_text_screen2">
              <HeaderText text={"Add Skills"} />
              <SubHeaderText text={"You can add upto 15 options"} />
            </div>
            <div className="card_tiles_sec">
              {jobSkills &&
                jobSkills.map((item) => {
                  return (
                    <CardTiles
                      key={item.id}
                      id={item.id}
                      text={item.skillName}
                      isActive={includes(selectedJobSkillIDs, item.id)}
                      setIsActive={(selected: Number) => {
                        onJobSkillsSelect(selected, item);
                      }}
                      getIdData={true}
                    />
                  );
                })}
            </div>
          </div>
          {!isEmpty(skillsError) && errorSec(skillsError)}

          <div className="continue_btn_container">
            <GenericButton
              onBtnClick={() => {
                onContinue();
              }}
            />
          </div>
        </div>
        <div className="showView">
          <JobRelatedInfoMap
            jobSkills={selectedJobSkillTexts}
            jobProfessions={selectedJobProfessionTexts}
            jobCategory={selectedJobCategoryText}
          />
        </div>
      </div>
    </div>
  );
}

export default JobRelatedInfo;
